import { t } from '@/lang'
import _ from 'lodash'
import { playTurboHostList } from '@/config/host'
import { NODE_ENV } from '@com/config/env'

// 新建弹窗跳转到埋点管理页
export function locationToPointManagement() {
  window.open(
    `${playTurboHostList[NODE_ENV]}/#/common-setting/account-auth?currentTab=1`,
    '_blank',
  )
}
